import styled from "styled-components/macro";
import { device } from "../../device";

export const Number = styled.div`
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background-color: #e5223c;
  color: #fff;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  flex-shrink: 0;

  @media ${device.mobileM} {
    width: 30px;
    font-size: 0.8125rem;
    height: 30px;
    margin-right: 15px;
  }

  @media ${device.tablet} {
    font-size: 1.125rem;
    height: 48px;
    width: 48px;
  }
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 0.8125rem;
  color: #3c4350;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 1.25rem;
  }
`;

export const Subtitle = styled.div`
  text-transform: uppercase;
  font-size: 0.512rem;
  color: #8b8b8b;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;

  justify-content: space-between;
  transition: all 0.4s;

  @media ${device.mobileM} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const PercentageChangeWrapper = styled.div`
  display: flex;
  width: 150px;
  justify-content: space-between;
  & > div:first-child {
    padding-right: 10px;
  }
  @media ${device.mobileM} {
    /* width: 130px; */
  }

  @media ${device.tablet} {
    width: 220px;
  }
  & > div {
    width: calc(100% / 2);
  }
`;

export const AveragePrice = styled.div`
  font-size: 0.5rem;
  font-size: 0.75rem;
  color: #8b8b8b;
  font-weight: bold;

  @media ${device.tablet} {
    font-size: 0.875rem;
  }
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnHeader = styled.div`
  min-width: none;
  width: 125px;
  word-break: break-all;
  @media ${device.mobileM} {
    width: 175px;
    /* width:auto; */
  }

  @media ${device.tablet} {
    width: 260px;
  }

  display: flex;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Content = styled.div`
  border-top: 1px solid #fff;
`;

export const Prices = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #eef5f5;

  @media ${device.tablet} {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

export const PricesHeading = styled.h3`
  font-size: 0.75rem;
  color: #047961;
  line-height: 1;
  padding: 0;
  margin: 0;
  text-align: center;
  padding-bottom: 10px;
  @media ${device.tablet} {
    font-size: 1.375rem;
    padding-bottom: 30px;
    font-weight: normal;
  }
`;
export const LivingCosts = styled.div`
  background: #630e34;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const LivingCostsHeadlines = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ToggleButton = styled.button`
  border: none;
  font-size: 1rem;
  background-color: #e5223c;
  font-weight: bold;
  height: 30px;
  width: 30px;
  color: #fff;
  cursor: pointer;
`;

function getBackgroundColorForIcon(props) {
  // If clicked on/active
  if (props.active) {
    return "#630E34";
  }

  if (props.increase) {
    return "#047961";
  }

  return "#E5223C";
}

export const StyledLocationDetail = styled.div`
  ${Content} {
    display: ${(props) => (props.active ? "block" : "none")};
  }

  ${Header} {
    background-color: ${(props) => (props.active ? "#EEF5F5" : "transparent")};
  }

  ${Number} {
    background-color: ${(props) => getBackgroundColorForIcon(props)};
  }
  ${ToggleButton} {
    background-color: ${(props) => getBackgroundColorForIcon(props)};
  }

  // If active override

  &:hover {
    background-color: #eef5f5;
  }
`;

export const LivingCostColumn = styled.div`
  width: calc(100% / 3);
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding-right: 10px;

  &:last-child {
    padding-right: 0;
  }
`;

export const LivingCostHeading = styled.h3`
  font-size: 0.64rem;
  color: #fefefe;
  font-weight: normal;
  text-align: center;

  @media ${device.tablet} {
    font-size: 0.7865rem;
  }
`;

export const LivingCostValue = styled.div`
  font-size: 0.9rem;
  color: #fefefe;
  @media ${device.tablet} {
    font-size: 1.25rem;
  }
`;

export const Circle = styled.div`
  height: 26px;
  width: 26px;
  border-radius: 50%;
  background-color: #fff;
  color: #630e34;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`;
export const ActionsWrapper = styled.div`
  width: 100%;
  padding-top: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  @media ${device.tablet} {
    justify-content: center;
  }
`;

export const HouseTypePricesWrapper = styled.div`
  display: flex;
  justify-content: center;
  & > * {
    padding-right: 15px;
  }

  & > :last-child {
    padding-right: 0;
  }
`;

export const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  @media ${device.tablet} {
    padding-left: 20px;
  }
`;

export const ShareText = styled.div`
  color: #fff;
  font-weight: bold;
  font-size: 0.625rem;
  padding-right: 15px;

  @media ${device.tablet} {
  }
`;

export const SocialButton = styled.button`
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  margin-right: 10px;
  background: none;
  transition: all 0.3s;
  &:hover {
    transform: scale(1.2);
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const SocialImage = styled.img`
  max-width: 100%;
  height: auto;
  width: 100%;
`;
